// extracted by mini-css-extract-plugin
export default {"text":"TextBlockText_text__MMDbI"};